export const categoriesList = [
  { id: 1, name: 'Brokastis' },
  { id: 2, name: 'Pusdienas' },
  { id: 3, name: 'Vakariņas' },
  { id: 4, name: 'Uzkodas' },
  { id: 5, name: '...' },
];
